import { FC, HTMLAttributes, useEffect, useRef } from 'react';

import styles from './SearchButton.module.css';

type SearchButtonAutoFocusProps = HTMLAttributes<HTMLButtonElement> & {
  autoFocus: boolean;
  size?: 24 | 'auto' | 'chip' | 'block';
};
const SearchButtonAutoFocus: FC<SearchButtonAutoFocusProps> = ({ autoFocus, size, children, ...btnProps }) => {
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (autoFocus) ref?.current?.focus();
  }, [autoFocus]);

  return (
    <button
      ref={ref}
      tabIndex={0}
      className={[styles.searchButton, styles[`searchButton${size}`], styles.searchButtonAutoFocus].join(' ')}
      data-auto-focus={autoFocus}
      {...btnProps}
    >
      {children}
    </button>
  );
};
export default SearchButtonAutoFocus;
